import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';

// Reducers
import userReducer from './reducers/users.reducer';
import alarmVelReducer from './reducers/alarm-vel.reducer';
import vehicleReducer from './reducers/vehicle.reducer';
import ceofenceReducer from './reducers/ceofence.reducer';
import profileReducer from './reducers/profile.reducer';
import performanceReportReducer from './reducers/performance-report.reducer';
import canHistoryReportReducer from './reducers/canHistory.reducer';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  // REDUCERS ALIMENTADOS DESDE EL API
  users: userReducer,
  alarmsVel: alarmVelReducer,
  vehicle: vehicleReducer,
  ceofence: ceofenceReducer,
  performanceReport: performanceReportReducer,
  // REDUCERS LAYOUT
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  profiles: profileReducer,
  product: persistReducer(productPersistConfig, productReducer),
  canHistory: canHistoryReportReducer,
  
});

export { rootPersistConfig, rootReducer };
